import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	item: {
		alignItems: "center",
		justifyContent: "space-between",
		borderRadius: 4,
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		border: "1px solid",
		padding: 16,
		borderColor: colors.gray[200]
	},
	chipContainer: {
		display: "flex",
		gap: "5px",
		flexFlow: "wrap"
	},
	planChip: {
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor()),
		color: colors.gray[0],
		fontWeight: "bold"
	},
	addonsChip: {
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[200]),
		color: colors.getPrimaryColor(),
		fontWeight: "bold"
	},
	title: {
		fontWeight: "bold",
		fontSize: "16px"
	},
	enabledLimitChip: {
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[200]),
		color: colors.getPrimaryColor(),
		fontWeight: "bold"
	},
	disabledLimitChip: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[200]),
		color: colors.gray[700]
	}
})

export default useStyles
